module.exports = __webpack_public_path__ + "media/audio.493891d5.mp3";